export default __webpack_public_path__ + "static/media/tradlyicon.b5a1a860.png";